import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { debounce, Popover } from "@mui/material";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import CurrencyInput from "react-currency-input-field";
import { NumericFormat } from "react-number-format";
import { useNavigate } from "react-router-dom";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { getAllProductPrice } from "../redux/handlers/logic/getAllProductPrice.handler";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { CSS } from "@dnd-kit/utilities";
import { calPriceByMstCategoryPriceTax, getUnitCost, getVatByMstCategoryPrice } from "utils/HelperFunction";
import { getSupplierProductName } from "utils/HelperProduct";
export default function Productrow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, poID = _param.poID, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "poID"
    ]);
    var _useSortable = useSortable({
        id: item.rowID
    }), attributes = _useSortable.attributes, listeners = _useSortable.listeners, setNodeRef = _useSortable.setNodeRef, transform = _useSortable.transform, transition = _useSortable.transition;
    var _useState = _sliced_to_array(useState([]), 2), productSearch = _useState[0], setProductSearch = _useState[1];
    var _useState1 = _sliced_to_array(useState([
        {
            warehouseID: 1,
            warehouseName: "คลัง 1"
        },
        {
            warehouseID: 2,
            warehouseName: "คลัง 2"
        },
        {
            warehouseID: 3,
            warehouseName: "คลัง 3"
        }
    ]), 2), warehouseSearch = _useState1[0], setWarehouseSearch = _useState1[1];
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "fs-12",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.barcode
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#8E8E8F"
                    },
                    children: item.dimProduct ? item.dimProduct.name_th : "-"
                })
            ]
        }, item.id);
    };
    var handleOnSelect = function(item, rowID) {
        setProductRow(function(prev) {
            return prev.map(function(el) {
                if (el.rowID === rowID) {
                    var _item_dimProduct, _item_dimProduct1;
                    var warehouseID = null;
                    var warehouseName = null;
                    if (values.is_one_receiving_point) {
                        warehouseID = values.dim_warehouse_id;
                        var warehouse = optionsWarehouse.find(function(item) {
                            return values.dim_warehouse_id === item.value;
                        });
                        warehouseName = warehouse ? warehouse.label : "";
                    }
                    var dim_mst_vat_id = null;
                    var vat = 0;
                    optionsMstVat.map(function(v) {
                        if (item.dimProduct && item.dimProduct.vat === "ไม่มี VAT" && v.value === 1) {
                            dim_mst_vat_id = v.value;
                            vat = v.vat;
                        }
                        if (item.dimProduct && item.dimProduct.vat === "VAT 0%" && v.value === 2) {
                            dim_mst_vat_id = v.value;
                            vat = v.vat;
                        }
                        if (item.dimProduct && item.dimProduct.vat === "VAT 7%" && v.value === 3) {
                            dim_mst_vat_id = v.value;
                            vat = v.vat;
                        }
                    });
                    var vatByMstCatPrice = getVatByMstCategoryPrice(values.dim_mst_price_category_id, dim_mst_vat_id, vat);
                    return _object_spread_props(_object_spread({}, el), {
                        productCode: item.dimProduct && item.dimProduct.sku ? item.dimProduct.sku : "-",
                        productID: item.id,
                        productName: item.dimProduct && item.dimProduct.name_th ? item.dimProduct.name_th : "-",
                        supplierCode: (_item_dimProduct = item.dimProduct) === null || _item_dimProduct === void 0 ? void 0 : _item_dimProduct.supplier_code,
                        supplierName: getSupplierProductName((_item_dimProduct1 = item.dimProduct) === null || _item_dimProduct1 === void 0 ? void 0 : _item_dimProduct1.supplier_names),
                        productRatioUnit: item.ratio_unit,
                        productContainer: item.container,
                        productBarcode: item.barcode,
                        sellPrice: item.price_1,
                        productPrice: getUnitCost(item),
                        productUnit: item.dimMasterUnit && item.dimMasterUnit.name ? item.dimMasterUnit.name : "-",
                        productUnitID: item.dimMasterUnit && item.dimMasterUnit.id ? item.dimMasterUnit.id : "-",
                        productOrdered: item.productOrdered,
                        ums: item.ums,
                        productStock: item.productStock,
                        warehouseID: warehouseID,
                        warehouseName: warehouseName,
                        discountType: 1,
                        discountPercent: 0,
                        discount: 0,
                        productQty: 1,
                        edit: false,
                        dim_mst_vat_id: vatByMstCatPrice.dim_mst_vat_id,
                        vat: vatByMstCatPrice.vat
                    });
                }
                return el;
            });
        });
    };
    var handleOnClear = function() {};
    var handleOnFocus = function() {
        var queryParams = {
            isWithOutDeleted: "true",
            limit: 10,
            searchText: ""
        };
        dispatch(getAllProductPrice({
            queryParams: queryParams,
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var handleOnSearch = function(searchText) {
        debouncedSearch(searchText.trim());
    };
    var getAllProductPriceReducer = useAppSelector(function(state) {
        return state.getAllProductPriceReducer;
    });
    var debouncedSearch = useMemo(function() {
        return debounce(function(searchText) {
            var queryParams = _object_spread({
                isWithOutDeleted: "true",
                limit: 10,
                searchText: searchText
            }, values.dim_supplier_information_id && {
                supInfoID: values.dim_supplier_information_id
            });
            dispatch(getAllProductPrice({
                queryParams: queryParams,
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }, 300);
    }, [
        productSearch
    ]);
    useEffect(function() {
        if (getAllProductPriceReducer.data && getAllProductPriceReducer.data.data.length > 0) {
            setProductSearch(getAllProductPriceReducer.data.data);
        }
    }, [
        getAllProductPriceReducer
    ]);
    var _useState2 = _sliced_to_array(useState(null), 2), anchorEl = _useState2[0], setAnchorEl = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), popid = _useState3[0], setPopid = _useState3[1];
    var formatResultWarehouse = function(item) {
        return /*#__PURE__*/ _jsx("div", {
            className: "fs-14",
            children: /*#__PURE__*/ _jsx("div", {
                style: {
                    color: "#8E8E8F"
                },
                children: item.label
            })
        }, item.value);
    };
    var _item_warehouseID, _item_discount, _item_note;
    return /*#__PURE__*/ _jsxs("tr", {
        className: "",
        children: [
            /*#__PURE__*/ _jsx("td", {
                style: customSort ? {
                    paddingLeft: 0
                } : {},
                children: customSort ? /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                    style: {
                        paddingLeft: "14px",
                        transform: CSS.Transform.toString(transform),
                        transition: transition
                    },
                    ref: setNodeRef
                }, attributes, listeners), {
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "btn-drag"
                    })
                })) : /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-start ",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mr-1",
                            children: [
                                index + 1,
                                ". "
                            ]
                        }),
                        /*#__PURE__*/ _jsx("input", {
                            className: "form-check-input",
                            type: "checkbox",
                            name: "",
                            checked: item.is_checked,
                            onChange: function(e) {
                                if (e.target.checked === true) {
                                    setProductRow(function(prev) {
                                        return prev.map(function(el) {
                                            if (el.rowID === item.rowID) {
                                                return _object_spread_props(_object_spread({}, el), {
                                                    is_checked: true
                                                });
                                            }
                                            return el;
                                        });
                                    });
                                } else {
                                    setProductRow(function(prev) {
                                        return prev.map(function(el) {
                                            if (el.rowID === item.rowID) {
                                                return _object_spread_props(_object_spread({}, el), {
                                                    is_checked: false
                                                });
                                            }
                                            return el;
                                        });
                                    });
                                }
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: !item.edit ? /*#__PURE__*/ _jsx("button", {
                    className: "btn btn-shadow fs-14",
                    style: {
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        minHeight: "35px"
                    },
                    onClick: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        edit: true
                                    });
                                }
                                return el;
                            });
                        });
                        if (rowCount - index <= 2) {
                            addProductRow(2);
                        }
                    },
                    children: item.productCode
                }) : /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                    items: productSearch,
                    placeholder: "",
                    onSelect: function(items) {
                        return handleOnSelect(items, item.rowID);
                    },
                    onClear: handleOnClear,
                    onFocus: handleOnFocus,
                    onSearch: handleOnSearch,
                    autoFocus: true,
                    formatResult: formatResult,
                    fuseOptions: {
                        keys: [
                            "barcode",
                            "dimProduct.name_th"
                        ]
                    },
                    resultStringKeyName: "barcode",
                    inputSearchString: item.barcode,
                    styling: {
                        height: "34px",
                        borderRadius: "10px",
                        border: 0,
                        fontSize: "14px",
                        boxShadow: "none",
                        zIndex: 1
                    },
                    showIcon: false,
                    showClear: false,
                    className: "scrollSearchAutocomplete"
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productName
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productBarcode
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            }) : "",
            columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("td", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "tc-15",
                                children: item.supplierCode
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            item.supplierName
                        ]
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            }) : "",
            /*#__PURE__*/ _jsx("td", {
                children: item.productID && /*#__PURE__*/ _jsxs("select", {
                    value: (_item_warehouseID = item.warehouseID) !== null && _item_warehouseID !== void 0 ? _item_warehouseID : "",
                    style: {
                        width: "100%",
                        border: !item.warehouseID ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                var selectedOption = e.target.options[e.target.selectedIndex];
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        warehouseID: e.currentTarget.value,
                                        warehouseName: selectedOption.text
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    disabled: values.is_one_receiving_point,
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            disabled: true,
                            children: "เลือกคลัง"
                        }, "default"),
                        optionsWarehouse && optionsWarehouse.map(function(v, index) {
                            return /*#__PURE__*/ _jsx("option", {
                                value: v.value,
                                children: v.label
                            }, index);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: !!item.productUnit && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        item.productUnit,
                        /*#__PURE__*/ _jsx("br", {}),
                        "1X",
                        item.productRatioUnit
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productID != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.productQty,
                    onFocus: function(e) {
                        return e.target.select();
                    },
                    onWheel: function(e) {
                        return e.target.blur();
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        productQty: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            columdisplay.productsOrdered || poID && values.dimMstNewStatus && values.dimMstNewStatus.id >= 4 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        style: {
                            backgroundColor: "#FFEDE0",
                            color: ""
                        },
                        children: item.productOrdered
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body bg-FFEDE0"
                    })
                ]
            }) : "",
            columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 0,
                            fixedDecimalScale: true,
                            value: item.productRatioUnit * item.productQty
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            }) : "",
            columdisplay.productsStock ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        style: {
                            backgroundColor: "#EDEDFF"
                        },
                        children: item.productStock
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body  bg-EDEDFF "
                    })
                ]
            }) : "",
            /*#__PURE__*/ _jsx("td", {
                children: item.productID ? /*#__PURE__*/ _jsx(CurrencyInput, {
                    placeholder: "",
                    defaultValue: item.productPrice || 0,
                    value: item.productPrice,
                    decimalsLimit: 4,
                    // fixedDecimalLength={2}
                    decimalScale: 4,
                    onValueChange: function(value, name, values) {
                        // console.log(value);
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        productPrice: value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control formv text-end me-2"
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsxs("td", {
                className: "position-reative",
                id: "pop".concat(index),
                children: [
                    /*#__PURE__*/ _jsxs("button", {
                        className: "btn w-100 btn-nhover",
                        type: "button",
                        id: "idd".concat(index),
                        style: {
                            height: "34px"
                        },
                        variant: "contained",
                        onClick: function(e) {
                            setPopid("sss2".concat(index));
                            setAnchorEl(e.currentTarget);
                        },
                        children: [
                            item.productID && (item.discount > 0 || item.discountType == 2) && /*#__PURE__*/ _jsx(_Fragment, {
                                children: item.discountType == 1 ? "".concat(item.discountPercent, " %") : item.discountType == 2 ? "บาท" : ""
                            }),
                            item.productID && !(item.discount > 0 || item.discountType == 2) && /*#__PURE__*/ _jsx("div", {
                                style: {
                                    color: "#565DFF"
                                },
                                children: "เลือกส่วนลด"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Popover, {
                        id: "sss2".concat(index),
                        open: "sss2".concat(index) == popid,
                        anchorEl: anchorEl,
                        onClose: function() {
                            setAnchorEl(null);
                            setPopid(null);
                        },
                        anchorPosition: {
                            left: 0,
                            top: 0
                        },
                        container: document.getElementById("pop".concat(index)),
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "p-3 text-start ",
                            style: {
                                width: "260px",
                                height: "160px"
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-3",
                                    children: "เลือกรูปแบบส่วนลด"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mb-2 d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Check, {
                                            inline: true,
                                            label: "เปอร์เซ็นต์ %",
                                            name: "",
                                            type: "radio",
                                            id: "x-radio-2".concat(index),
                                            className: "form-check-st-2 tc-7",
                                            checked: item.discountType == 1,
                                            onChange: function(e) {
                                                setProductRow(function(prev) {
                                                    return prev.map(function(el) {
                                                        if (el.rowID === item.rowID) {
                                                            return _object_spread_props(_object_spread({}, el), {
                                                                discountType: 1,
                                                                discount: el.productPrice * parseFloat(el.discountPercent) / 100
                                                            });
                                                        }
                                                        return el;
                                                    });
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "number",
                                            name: "",
                                            className: "form-control text-center",
                                            placeholder: "",
                                            value: item.discountPercent,
                                            style: {
                                                width: "60px"
                                            },
                                            onChange: function(e) {
                                                setProductRow(function(prev) {
                                                    return prev.map(function(el) {
                                                        if (el.rowID === item.rowID) {
                                                            return _object_spread_props(_object_spread({}, el), {
                                                                discountPercent: e.target.value,
                                                                discount: el.productPrice * parseFloat(e.target.value) / 100
                                                            });
                                                        }
                                                        return el;
                                                    });
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                        inline: true,
                                        label: "บาท",
                                        name: "",
                                        type: "radio",
                                        id: "x-radio-1".concat(index),
                                        className: "form-check-st-2 tc-7",
                                        checked: item.discountType == 2,
                                        onChange: function(e) {
                                            setProductRow(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            discountType: 2
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "text-end",
                children: item.discountType == 1 ? /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 4,
                    fixedDecimalScale: true,
                    value: item.productPrice * parseFloat(item.discountPercent) / 100
                }) : item.discountType == 2 ? /*#__PURE__*/ _jsx(CurrencyInput, {
                    placeholder: "",
                    defaultValue: (_item_discount = item.discount) !== null && _item_discount !== void 0 ? _item_discount : 0,
                    value: values.discount,
                    decimalsLimit: 4,
                    // fixedDecimalLength={2}
                    decimalScale: 4,
                    onValueChange: function(value, name, values) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        discount: value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control formv text-end me-2"
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productID ? /*#__PURE__*/ _jsx("select", {
                    value: item.dim_mst_vat_id,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var vat = optionsMstVat.find(function(v) {
                                        return v.value == e.currentTarget.value;
                                    });
                                    vat = vat ? vat.vat : 0;
                                    return _object_spread_props(_object_spread({}, el), {
                                        dim_mst_vat_id: e.currentTarget.value,
                                        vat: vat
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: optionsMstVat && optionsMstVat.map(function(v, index) {
                        return /*#__PURE__*/ _jsx("option", {
                            value: v.value,
                            children: v.label
                        }, index);
                    })
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "text-end",
                children: !isNaN(item.productPrice) ? /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 2,
                    fixedDecimalScale: true,
                    value: calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, true)
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: !isNaN(item.productPrice) ? /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            value: calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, false) - calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, true)
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            }) : "",
            columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: !isNaN(item.productPrice) ? /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            value: calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, false)
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            }) : "",
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv text-start border-0 me-2",
                    value: (_item_note = item.note) !== null && _item_note !== void 0 ? _item_note : "",
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        note: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            })
        ]
    });
}
